module.exports = __webpack_public_path__ + "img/img.f083fce0.png";